import { userInitialState, UserState } from './initialState/user';
import { userActionTypes } from '@actions/actionTypes/user';
import { AnyAction } from 'redux';

export const userReducer = (state = userInitialState, action: AnyAction): UserState => {
  switch (action.type) {
    case userActionTypes.SET_CURRENT_USER: {
      return { ...state, currentUser: action.payload };
    }
    case userActionTypes.SET_USER_METADATA: {
      return { ...state, metadata: action.payload };
    }
    case userActionTypes.SET_USERS: {
      return {
        ...state,
        users: action.payload,
      };
    }
    case userActionTypes.SET_USERS_TOTAL: {
      return {
        ...state,
        total: action.payload,
      };
    }
    case userActionTypes.SET_USERS_FILTERS: {
      return { ...state, usersFilters: action.payload };
    }
    default: {
      return state;
    }
  }
};
